import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import DeleteModal from "components/Common/DeleteModal"
import FacilityListComponent from "components/Facility/list"
import {
  deleteFacility,
  exportFacilities,
  getFacilities,
} from "store/facility/facility-action"

const FacilityList = () => {
  const dispatch = useDispatch()
  const { data, error, loading, exportStatus } = useSelector(
    state => state.facility
  )
  const [deleteModal, setDeleteModal] = useState(false)
  const [facility, setFacility] = useState(null)
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(10)
  const [according, setAccording] = useState({ order: "desc", name: "id" })

  // call delete faculity function when data button clicked
  const handleDeleteFunc = data => {
    if (facility) {
      dispatch(deleteFacility(facility.id))
    }
    setDeleteModal(false)
  }

  // Open Modal When Delete button clicked
  const onClickDelete = data => {
    setFacility(data)
    setDeleteModal(true)
  }

  // Fetches new facilities when a page number is clicked
  const onPageClick = link => {
    dispatch(getFacilities(link.url, pageNumber, according, search))
  }

  // Updates search value when a new search is performed
  const onSearchHandler = value => {
    setSearch(value)
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Updates the ordering based on user selection
  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  // useEffect Hook to Fetch Facilities Data with Debounced Search:
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      dispatch(getFacilities(undefined, undefined, undefined, search))
    }, 1500)

    return () => clearTimeout(delayDebounceFn)
  }, [search])

  // useEffect Hook to Fetch Facilities Data with Debounced page Number and accroding:
  useEffect(() => {
    dispatch(getFacilities(undefined, pageNumber, according, search))
  }, [pageNumber, according])

  // Trigger Export Function When Export Button is Clicked.
  const onExportBtnClick = () => {
    dispatch(exportFacilities(search))
  }

  return (
    <React.Fragment>
      {/* Delete Modal */}
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteFunc}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Breadcrumbs title={"Admin"} breadcrumbItem={"Facilities"} />
      {/* Facility list Component */}
      <FacilityListComponent
        data={data}
        error={error}
        loading={loading}
        onClickDelete={onClickDelete}
        handleDeleteFunc={handleDeleteFunc}
        onPageClick={onPageClick}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onExportBtnClick={onExportBtnClick}
        exportStatus={exportStatus}
      />
    </React.Fragment>
  )
}

export default FacilityList
